// extracted by mini-css-extract-plugin
export default {"title":"dialog_title__-meG8","content":"dialog_content__sjSKt","input":"dialog_input__iHcbe","button":"dialog_button__iaz6l"};